const managerFocus = [
  'защищает интересы конкретной сделки;',
  'работает с интересами конкретного клиента;',
  'отвечает за результат отдельного проекта;',
  'видит задачу в границах своей функции.',
];

const leaderFocus = [
  'интересы компании в целом;',
  'интересы команды и сотрудников;',
  'финансовый результат бизнеса;',
  'долгосрочные отношения;',
  'риски и их последствия;',
  'ответственность за решение;',
  'репутацию компании;',
  'последствия решения в перспективе.',
];

export default function ManagerVsLeader() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Чем переговоры руководителя отличаются от переговоров менеджера
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          У руководителя выше цена ошибки — поэтому он видит переговоры шире, чем способ получить уступку
        </p>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                <i className="ri-user-line text-gray-600 text-lg"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">Менеджер</h3>
            </div>
            <p className="text-sm text-gray-600 mb-4">Чаще защищает интересы конкретной сделки, клиента или проекта:</p>
            <div className="space-y-2.5">
              {managerFocus.map((m, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-gray-400 mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700 leading-relaxed">{m}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-teal-50 rounded-2xl border border-teal-200 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-teal-600 flex items-center justify-center">
                <i className="ri-vip-crown-line text-white text-lg"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">Руководитель</h3>
            </div>
            <p className="text-sm text-gray-600 mb-4">Одновременно учитывает:</p>
            <div className="space-y-2.5">
              {leaderFocus.map((l, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm text-gray-800 leading-relaxed">{l}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Руководитель видит переговоры не только как способ получить уступку, но и как инструмент управления людьми и бизнесом.
          </p>
        </div>
      </div>
    </section>
  );
}